module.exports = __webpack_public_path__ + "img/map_down.62343731.png";